module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Battery-half-fdfbe9acfbf62049eafb0d2c0b24d8f0.svg";